import config from "src/config.js";
import {
  BaseService
} from "../base.service";

const baseUrl = config.apiUrl;
const baseEndpoint = "/location";
const getLocationEndpoint = "/location/{id}";

export class LocationService extends BaseService {
  async search(searchParam, signal) {
    const uri = new URL(baseUrl + baseEndpoint + "/search");

    const response = await fetch(uri.toString(), this.header({
      method: "POST",
      body: JSON.stringify(searchParam),
      signal,
    }));

    if (!response.ok && response.status !== 404)
      throw new Error(await response.json().then((body) => body.message));

    return await response.json();
  }

  async getAll() {
    const uri = new URL(baseUrl + baseEndpoint);

    const response = await fetch(uri.toString(), this.header());
    return await response.json();
  }

  async getById(locationId) {
    const response = await fetch(
      baseUrl + getLocationEndpoint.replace("{id}", locationId),
      this.header()
    );
    const result = await response.json();
    return result;
  }

  async create(location) {
    const uri = new URL(`${baseUrl}${baseEndpoint}`);

    const response = await fetch(
      uri.toString(),
      this.header({
        method: "POST",
        body: JSON.stringify(location),
      })
    );

    if (response.status !== 200) {
      const data = await response.json();
      throw new Error(data.message);
    }

    return await response.json();
  }

  async update(location) {
    const uri = new URL(`${baseUrl}${baseEndpoint}/${location._id}`);

    const response = await fetch(
      uri.toString(),
      this.header({
        method: "POST",
        body: JSON.stringify(location),
      })
    );

    if (response.status !== 200) {
      const data = await response.json();
      throw new Error(data.message);
    }

    return await response.json();
  }
}